import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';

const LoomEmbedComponent = (props: any) => {
  const { node } = props;
  const videoId = node.attrs.videoId;

  if (!videoId) {
    return (
      <NodeViewWrapper className="loom-embed-nodeview">
        <div className="p-2 border border-dashed border-muted-foreground text-muted-foreground">
          Invalid Loom Link
        </div>
      </NodeViewWrapper>
    );
  }

  const embedUrl = `https://www.loom.com/embed/${videoId}`;

  return (
    <NodeViewWrapper className="loom-embed-nodeview my-2 relative" data-drag-handle>
      <div style={{ position: 'relative', paddingBottom: '62.5%', height: 0 }}>
        <iframe
          src={embedUrl}
          // Tiptap handles selection, so disable pointer events on the iframe itself
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          frameBorder="0"
          allowFullScreen
          title={`Loom Video Embed ${videoId}`}
        ></iframe>
      </div>
    </NodeViewWrapper>
  );
};

export default LoomEmbedComponent;
